import React from 'react'
import { FaCalendarAlt, FaMapMarkerAlt, FaClock } from 'react-icons/fa'
import moment from "moment"
import "moment/locale/es"
import { PiShoppingCartDuotone } from 'react-icons/pi'
moment.locale("es")

export default function CarouselChild({ eventId, eventType, eventName, eventDesc, eventPlace, eventDate, routeChange, eventImages }) {
    const nameParts = eventName.trim().split(" ")
    const firstWord = nameParts[0]
    const restOfName = nameParts.slice(1).join(" ")

    const URL_ORIGIN = process.env.NODE_ENV === "development"
        ? process.env.REACT_APP_API_URL_DEV
        : process.env.REACT_APP_API_URL;

    return (
        <div className="w-full md:h-[75vh] flex flex-col md:flex-row bg-[#0f0e17] text-white md:overflow-hidden">
            <div className="w-full md:w-1/2 md:h-full relative flex-shrink-0">
                {eventImages.map((img, index) => {
                    if (img.is_primary) {
                        return (
                            <img
                                key={index}
                                src={`${URL_ORIGIN}/image-proxy?id=${img.id}`}
                                alt={img.image_name || "Event image"}
                                className="detail-image w-full block md:absolute md:inset-0 md:w-full md:h-full md:object-contain md:object-center"
                            />
                        )
                    }
                })}
                <div className="absolute inset-0 bg-gradient-to-t from-[#0f0e17] via-transparent to-transparent opacity-70 md:hidden" />
                <div className="absolute inset-0 hidden md:block bg-gradient-to-r from-transparent via-transparent to-[#0f0e17]" />
            </div>

            <div className="relative z-[20] w-full md:w-1/2 flex flex-col justify-center px-6 md:px-12 py-8 text-center md:text-left gap-4">

                <h2 className="detail-title font-display text-3xl sm:text-4xl md:text-5xl font-bold leading-tight">
                    {firstWord}
                    {restOfName && (
                        <>
                            <br />
                            <span className="text-transparent bg-clip-text gradient-monoparty-text">
                                {restOfName}
                            </span>
                        </>
                    )}
                </h2>

                <p className="detail-description text-gray-400 text-sm md:text-base leading-relaxed line-clamp-3">
                    {eventDesc}
                </p>

                <div className="detail-info flex flex-col gap-2 text-gray-300 text-sm">
                    <div className="flex items-center gap-2 justify-center md:justify-start">
                        <FaMapMarkerAlt className="text-brand shrink-0" />
                        <span className="truncate max-w-xs">{eventPlace}</span>
                    </div>
                    <div className="flex items-center gap-2 capitalize justify-center md:justify-start">
                        <FaCalendarAlt className="text-brand shrink-0" />
                        {moment(eventDate).utcOffset(0, true).format("dddd, D [de] MMMM [del] YYYY")}
                    </div>
                    <div className="flex items-center gap-2 justify-center md:justify-start">
                        <FaClock className="text-brand shrink-0" />
                        {moment(eventDate).utcOffset(0, true).format("hh:mm a")}
                    </div>
                </div>

                <div className="flex justify-center md:justify-start mt-2">
                    <button
                        className="detail-btn event-one__btn thm-btn px-8 py-3"
                        onClick={() => routeChange(eventId)}
                        onTouchStart={(e) => e.stopPropagation()}
                        onTouchEnd={(e) => { e.stopPropagation(); e.preventDefault(); routeChange(eventId); }}
                    >
                        <span className="flex items-center gap-2">
                            <PiShoppingCartDuotone size={22} />
                            Comprar boletos
                        </span>
                    </button>
                </div>
            </div>
        </div>
    )
}
